import get from "lodash.get";
import React, { FC } from "react";
import {
	useController,
	useFormContext,
	useFormState,
	useWatch
} from "react-hook-form";
import { validateOptionalUrl } from "src/utils/validateUrl";

interface Props {
	stepNumber: number;
	order: number;
}

const TextStep: FC<Props> = ({ stepNumber, order }) => {
	const { control } = useFormContext<BannerFormState>();

	const isStepDisabled = useWatch({
		name: `steps.${stepNumber - 1}.isStepDisabled`,
		control
	});

	const optional = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.optional`
	});

	const isUrl = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.isUrl`
	});

	const required = isStepDisabled || optional ? false : true;

	const rules = {
		required,
		validate: isUrl ? validateOptionalUrl : undefined
	};

	const { field } = useController({
		name: `steps.${stepNumber - 1}.fields.${order - 1}.givenAnswer`,
		control,
		rules
	});

	const placeholder = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.placeholder`
	});

	const maxLength = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.maxChar`
	});

	const { errors } = useFormState({ control });

	const isAnswerInvalid = Boolean(
		get(errors, `steps[${stepNumber - 1}].fields[${order - 1}]`, null)
	);

	return (
		<div className="flex flex-col w-full">
			<input
				id={`step-${stepNumber}`}
				type="text"
				placeholder={placeholder}
				className={[
					"w-full bg-white px-3 py-2 rounded-lg border text-base text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring transition-colors",
					isAnswerInvalid ? "border-red-500" : "border-border"
				].join(" ")}
				aria-label={`step-${stepNumber}-order-${order}`}
				maxLength={maxLength as number}
				{...field}
			/>
			{maxLength && (
				<span
					aria-label="character-count"
					className="text-[13px] text-zinc-600 self-end mt-1"
				>
					{field.value?.length} / {maxLength}
				</span>
			)}
		</div>
	);
};

export default TextStep;
